import { GET_CHANNEL_DATA_FAILURE, GET_CHANNEL_DATA_REQUEST, GET_CHANNEL_DATA_RESET, GET_CHANNEL_DATA_SUCCESS } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getChannelDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CHANNEL_DATA_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_CHANNEL_DATA_REQUEST:
            return Object.assign({}, state);
        case GET_CHANNEL_DATA_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case GET_CHANNEL_DATA_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null });
        default:
            return state;
    }
};
export default getChannelDataReducer;
